<template>
  <div v-if="type === 'appartment'" class="c-listitem">
    <div class="c-listitem-part">
      <p class="c-listitem-text c-listitem-text--bold">{{item.roomsNumber}}</p>
      <p class="c-listitem-text c-listitem-text--grey">{{item.roomText}}</p>
    </div>
    <div class="c-listitem-part c-listitem-part--mid">
      <p v-if="item.sizeFrom && item.sizeTo" class="c-listitem-text c-listitem-text--bold">{{item.sizeFrom}} - {{item.sizeTo}}</p>
      <p v-else-if="item.sizeFrom || item.sizeTo" class="c-listitem-text c-listitem-text--bold">{{item.sizeFrom}}{{item.sizeTo}}</p>

      <p class="c-listitem-text c-listitem-text--grey">{{item.sizeText}}</p>
    </div>
    <div class="c-listitem-part c-listitem-part--last">
      <p class="c-listitem-text c-listitem-text--grey">{{item.totalAppartments}}</p>
      <p class="c-listitem-text c-listitem-text--grey">{{item.totalAppartmentsText}}</p>
    </div>
  </div>

  <div v-else-if="type === 'timeline'" class="c-listitem">
    <div class="c-listitem-part">
      <p class="c-listitem-text c-listitem-text--grey">{{item.label}}</p>
    </div>
    <div class="c-listitem-part c-listitem-part--last">
      <p :class="[
        'c-listitem-text',
        { 
          'c-listitem-text--bold': item.active,
          'c-listitem-text--grey': !item.active
        }
      ]">{{item.statusText}}</p>
    </div>
  </div>

  <div v-else-if="type === 'fullText'" class="c-listitem">
    <div class="c-listitem-part">
      <p v-if="!item.url" :class="[
        'c-listitem-text',
        { 
          'c-listitem-text--bold': item.active,
          'c-listitem-text--grey': !item.active
        }
      ]">{{item.statusText}}</p>
      <a v-if="item.url" :href="item.url" class="c-listitem-text">
        {{item.statusText}}
      </a>
    </div>
  </div>
</template>

<script>
import VIcon from '../../components/icon/VIcon';

export default {
  name: 'VListItem',
  components : {
    VIcon
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
    type: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    }
  },
  methods: {
    
  }
}
</script>